<template>
    <div class="ck-data-tables">
      <div>
        <input type="text"
                   class="form-control"
                   placeholder="Search"
                   v-model="globalSearch"
                   @input="onGlobalSearchInput"/>
      </div>
      <div class="ck-tbl-dynamix">
        <table id="tbl-minmax" class="table table-bordered table-hover table-inline-edit">
                <thead class="thead-dark">
                    <tr>
                      <th v-for="item in thead" :key="'header-'+item.key">
                        <div class="dataviewer-th" @click="item.sort ? sort(item.key) : null"
                             :style="{cursor: item.sort ? 'pointer' : 'default'}">
                          <span>{{ item.title }}</span>
                                <span v-if="params.column === item.key">
                                    <span v-if="params.direction === 'asc'">&#x25B2;</span>
                                    <span v-else>&#x25BC;</span>
                                </span>
                            </div>
                        </th>
                      <th>Actions</th>
                    </tr>
                    <!--<tr>
                      <th v-for="item in thead" :key="'filter-'+item.key">
                        <input
                            type="text"
                            class="form-control form-control-sm"
                            v-model="filters[item.key]"
                            @input="onFilterChange"
                            :placeholder="`Filter ${item.title}`"
                        />
                      </th>
                      <th></th>
                    </tr>-->
                </thead>
                <tbody>
                    <slot v-for="item in model.data" :item="item">{{ model.data }}</slot>
                </tbody>
            </table>
        </div>
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3 p-2 border rounded bg-light">

        <!-- LEFT SIDE: Pagination Controls -->
        <div class="d-flex align-items-center gap-3 flex-wrap">

          <!-- Left Controls -->
          <div class="btn-group">
            <button class="btn btn-sm btn-outline-primary" :disabled="params.page === 1" @click="goToFirst">
              « First
            </button>
            <button class="btn btn-sm btn-outline-primary" :disabled="params.page === 1" @click="prev">
              ‹ Prev
            </button>
          </div>
          <!-- Page Input + Status -->
          <div class="d-flex align-items-center gap-2 px-1">
            <span class="px-2">Page</span>
            <input type="number"
                   v-model.number="params.page"
                   @change="onPageInput"
                   min="1"
                   :max="model.last_page"
                   class="form-control form-control-sm text-center"
                   style="width: 70px;">

            <span class="px-2">of {{ model.last_page || 1 }}</span>
          </div>
          <!-- Right Controls -->
          <div class="btn-group">
            <button class="btn btn-sm btn-outline-primary" :disabled="!model.next_page_url" @click="next">
              Next ›
            </button>
            <button class="btn btn-sm btn-outline-primary" :disabled="params.page === model.last_page" @click="goToLast">
              Last »
            </button>
          </div>

        </div>

        <!-- RIGHT SIDE: Entry Count -->
        <div class="text-muted text-end">
          Showing <strong>{{ model.from || 0 }}</strong> to <strong>{{ model.to || 0 }}</strong>
          of <strong>{{ model.total || 0 }}</strong> entries
        </div>

      </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios'

    import { bus } from './../../../main.js'

    export default {
        name: 'DataViewer',
        props: ['formName', 'source', 'thead', 'filter', 'create', 'title'],
        data() {
            return {
                loader: true,
                showFilter: false,
                model: {
                    data: []
                },
                params: {
                  per_page: 10,
                  page: 1,
                  column: 'id',
                  direction: 'desc',
                  search_column: 'id',
                  search_operator: 'equal_to',
                  search_query: '',
                },
                filters: {},
                operators: {
                    equal_to: '=',
                    not_equal: '<>',
                    less_than: '<',
                    greater_than: '>',
                    less_than_or_equal_to: '<=',
                    greater_than_or_equal_to: '>=',
                    in: 'IN',
                    not_in: 'NOT IN',
                    like: 'LIKE',
                    between: 'BETWEEN'
                },
              globalSearch: ''
            }
        },
        beforeMount() {
            this.fetchData()
        },
        created() {
            bus.$on("fetch-data", (data) => {
                this.fetchData();
            });
        },
        methods: {
            next() {
                if(this.model.next_page_url) {
                    this.params.page++
                    this.fetchData()
                }
            },
            prev() {
                if(this.model.prev_page_url) {
                    this.params.page--
                    this.fetchData()
                }
            },
            sort(column) {
                if(column === this.params.column) {
                    if(this.params.direction === 'desc') {
                        this.params.direction = 'asc'
                    } else {
                        this.params.direction = 'desc'
                    }
                } else {
                    this.params.column = column
                    this.params.direction = 'asc'
                }

              this.fetchData()
            },
          addForm(id) {
            bus.$emit(this.formName, {
              form: 'add'
            });
          },
          goToFirst() {
            this.params.page = 1;
            this.fetchData();
          },
          goToLast() {
            this.params.page = this.model.last_page;
            this.fetchData();
          },
          onPageInput() {
            if (this.params.page < 1) {
              this.params.page = 1;
            } else if (this.params.page > this.model.last_page) {
              this.params.page = this.model.last_page;
                }
                this.fetchData();
            },
            onFilterChange() {
                this.fetchData();
            },
          onGlobalSearchInput() {
            this.params.search_column = 'all';
            this.params.search_operator = 'like';
            this.params.search_query = this.globalSearch;
            this.params.page = 1;
            this.fetchData();
          },
            fetchData() {
              this.loader = true;
              axios.get(this.buildURL())
                  .then(response => {
                    // Assuming response.data.model contains data and pagination
                    if (response.data && response.data.model) {
                      const model = response.data.model;
                      // Set data array
                      Vue.set(this.$data.model, 'data', model.data || []);
                      // Set pagination info
                      Vue.set(this.$data.model, 'total', (model.pagination && model.pagination.total) || 0);
                      Vue.set(this.$data.model, 'per_page', (model.pagination && model.pagination.per_page) || this.params.per_page);
                      Vue.set(this.$data.model, 'current_page', (model.pagination && model.pagination.current_page) || this.params.page);
                      Vue.set(this.$data.model, 'last_page', (model.pagination && model.pagination.last_page) || 1);

                      // Optionally, set next_page_url and prev_page_url for convenience
                      Vue.set(this.$data.model, 'next_page_url', model.pagination && model.pagination.current_page < model.pagination.last_page ? true : false);
                      Vue.set(this.$data.model, 'prev_page_url', model.pagination && model.pagination.current_page > 1 ? true : false);

                      // Set from and to
                      Vue.set(this.$data.model, 'from', model.pagination ? ((model.pagination.current_page - 1) * model.pagination.per_page + 1) : 0);
                      const to = model.pagination ? (model.pagination.current_page * model.pagination.per_page) : 0;
                      Vue.set(this.$data.model, 'to', to > (model.pagination && model.pagination.total ? model.pagination.total : 0) ? (model.pagination && model.pagination.total) : to);

                    } else {
                      // fallback if no model
                      Vue.set(this.$data.model, 'data', []);
                      Vue.set(this.$data.model, 'total', 0);
                      Vue.set(this.$data.model, 'per_page', this.params.per_page);
                      Vue.set(this.$data.model, 'current_page', 1);
                      Vue.set(this.$data.model, 'last_page', 1);
                      Vue.set(this.$data.model, 'next_page_url', false);
                      Vue.set(this.$data.model, 'prev_page_url', false);
                    }
                    this.loader = false;
                  })
                  .catch(error => {
                    console.error(error);
                    this.loader = false;
                    if (error.response && error.response.status === 401) {
                      this.$auth.destroyToken();
                      location.reload();
                    }
                  });
            },
          buildURL() {
            var p = this.params
                return `${this.source}?column=${p.column}&direction=${p.direction}&per_page=${p.per_page}&page=${p.page}&search_column=${p.search_column}&search_operator=${p.search_operator}&search_query=${p.search_query}`
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/users/common/DataViewer.vue